import clsx from 'clsx'
import React, { Dispatch, ReactNode, SetStateAction } from 'react'
import { Controller, FieldValues } from 'react-hook-form'
import { FormattedMessage } from 'react-intl'

import s from './styles.module.scss'

import { HouseSearchTransportDuration } from './house-search-transport-duration/HouseSearchTransportDuration'
import { HouseSearchTransportType } from './house-search-transport-type/HouseSearchTransportType'
import { ControlledCommons } from '../../input-text/input-text'
import { Transport_Type } from '../../../../lib/graphql'
import { IconSvg, Tooltip } from '../../../atoms'

interface HouseSearchTravelTimeProps<T extends FieldValues>
  extends ControlledCommons<T> {
  title: ReactNode
  disabled: boolean
  setTransportType: Dispatch<SetStateAction<Transport_Type>>
  transportType: Transport_Type
}

export const HouseSearchTravelTime = <T extends FieldValues>({
  control,
  name,
  rules,
  disabled,
  title,
  setTransportType,
  transportType,
}: HouseSearchTravelTimeProps<T>) => {
  return (
    <Tooltip
      content={
        <FormattedMessage
          id='ui.HouseSearchTravelTime.selectDestination'
          defaultMessage="Renseignez une destination afin d'utiliser cette fonctionnalité"
        />
      }
      className={clsx({
        [s.disabled]: disabled,
      })}
      contentClassName={s.tooltip}
      position='center'
      disable={!disabled}
    >
      <div
        className={clsx(s.container, {
          [s.disabled]: disabled,
        })}
      >
        <p className={s.containerTitle}>{title}</p>
        <Controller
          name={name}
          rules={rules}
          control={control}
          render={({ field }) => (
            <>
              <HouseSearchTransportType
                onClick={(type) => {
                  setTransportType(type)
                  if (field.value?.transportTime) {
                    field.onChange({
                      transportTime: field.value.transportTime,
                      transportType: type,
                    })
                  }
                }}
                value={transportType}
                disabled={disabled}
                labelDriving={
                  <p>
                    <IconSvg.CarOutline />
                    <FormattedMessage
                      id='ui.HouseSearchTravelTime.car'
                      defaultMessage='Voiture'
                    />
                  </p>
                }
                labelTransit={
                  <p>
                    <IconSvg.TrainOutline />
                    <FormattedMessage
                      id='ui.HouseSearchTravelTime.train'
                      defaultMessage='Train'
                    />
                  </p>
                }
              />
              <HouseSearchTransportDuration
                onClick={(value) => {
                  if (value !== field?.value?.transportTime) {
                    field.onChange({
                      transportTime: value,
                      transportType,
                    })
                  }
                }}
                selectedValue={field.value?.transportTime}
                disabled={disabled}
              />
            </>
          )}
        />
      </div>
    </Tooltip>
  )
}
